import React from "react";
import { Table } from "react-bootstrap";
import ReactDataTable from '../../../../Dashboards/ItDashboard/It Officer/Components/Table/ItDataTable'
import { GoLog } from "react-icons/go";

export default function CameraLogsTable({ logs }) {

const Logs_Column = [
  {
    name: "Sr.",
    selector: (row, idx) => idx + 1,
    width: "60px",
    center: true,
    sortable: false,
  },
  {
    name: "Date",
    selector: row => row.date,
    sortable: true,
    center: true,
  },
  {
    name: "Time",
    selector: row => row.time,
    sortable: false,
    center: true,
  },
  {
    name: "Inactive Duration",
    selector: row => row.inactive,
    sortable: false,
    center: true,
    cell: row => (
      <span style={{ color: "#e67e22", fontWeight: 500 }}>{row.inactive}</span>
    ),
  },
];
  return (
<div className="mt-3">
    <h5 className="my-4 ps-3"> <span><GoLog /></span> Camera Logs</h5>
    <div className="text-center my-2">
    <small className="text-center f-light">The 'inactive' time represents the gap, in minutes, between consecutive log entries, indicating how much time has passed between the last recorded activity and the current one.</small>
    </div>
    <ReactDataTable
        title="Camera Logs"
        noCardHeader
        staticData={logs || []}
        tableColumns={Logs_Column}
    />
</div>
  );
}